import { ArrowLeftOutlined, ArrowRightOutlined } from "@@/elements/Icons/icons";
import { useContext } from "react";
import cn from "classnames";
import ScrollerContext from "../context";
import css from "./index.module.scss";

export type NavButtonProps = {
  direction?: "left" | "right";
};

const NavButton = ({ direction = "left" }: NavButtonProps) => {
  const {
    isAtStart,
    isAtEnd,
    gotoNext,
    gotoPrev,
  } = useContext(ScrollerContext);

  const hidden = (direction === "left" && isAtStart) || (direction === "right" && isAtEnd);

  const onClick = () => {
    if (hidden) return;
    if (direction === "left") {
      gotoPrev();
    } else {
      gotoNext();
    }
  };

  const className = cn(
    css.button,
    { [css.button__disabled]: hidden },
  );

  return (
    <button className={className} disabled={hidden} onClick={onClick} aria-label={direction} type="button">
      {direction === "left" ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
    </button>
  );
};

export default NavButton;
